window.disallowedTooltip = function(elementsSelector, tooltippSelector) {

    const allDisallowedElements = Array.from(document.querySelectorAll(elementsSelector));
    const disallowedTooltip = document.querySelector(tooltippSelector);

    //console.log("allDisallowedElements",allDisallowedElements);

    //Bail, if tooltip is not there or no elements need tooltip
    if (!disallowedTooltip || !allDisallowedElements.length) return;


    allDisallowedElements.map((el, i) => {
        el.addEventListener("mouseover", () => {
            handleMouse(true, el, disallowedTooltip)
        })

        el.addEventListener("mouseleave", () => {
            handleMouse(false, el, disallowedTooltip)
        })
    });
}

window.handleMouse = function(hover, el, disallowedTooltip) {
    if(hover) {
        //If mouse has entered

        //Get position of element
        const offset = (el) => {
            var rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { bottom: rect.bottom + scrollTop, left: rect.left + scrollLeft }
        }

        const elOffset = offset(el);

        disallowedTooltip.style.top = `${elOffset.bottom  + 5}px` ;
        disallowedTooltip.style.left = `${elOffset.left + 5}px`;
        disallowedTooltip.classList.add("active");

        return true;
    }

    disallowedTooltip.classList.remove("active");
    return false;
}

document.addEventListener("DOMContentLoaded", function () {

    disallowedTooltip(".disallowed", ".disallowed-tooltip");
    disallowedTooltip(".disallowed-for-you", ".disallowed-for-you-tooltip");

});

const loadMoreButton = document.querySelector('.loadMore')
  